import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { DepartmentRequest } from '../../../Data/Department';
import { dictionary } from '../../../dictionary';
import { NotificationType } from '../../../redux/initialState';
import { addNotification } from '../../../redux/notifications/notificationsActionCreator';
import { departmentService } from '../../../Services/DepartmentService';
import { FormFlow } from '../../../Shared/FormFlow/FormFlow';
import { routes } from '../../../Utils/routes';
import { DepartmentForm } from '../shared/DepartmentForm';

export const CreateDepartment: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onCancel = () => history.push(routes.departments.index);
  const onComplete = async (request: DepartmentRequest) => {
    try {
      await departmentService.create(request);
      dispatch(addNotification(NotificationType.success, dictionary.CREATE_DEPARTMENT_SUCCESS));
      history.push(routes.departments.index);
    } catch (exception) {
      if (exception?.response?.status === 409) {
        dispatch(addNotification(NotificationType.error, dictionary.CREATE_DEPARTMENT_UNIQUE_ERROR(exception.response.data?.data)));
      } else {
        dispatch(addNotification(NotificationType.error, dictionary.CREATE_DEPARTMENT_ERROR));
      }
    }
  };

  return (
    <FormFlow<DepartmentRequest>
      onComplete={onComplete}
      onCancel={onCancel}
      completeButtonLabel={dictionary.CREATE_DEPARTMENT_SUBMIT_BTN}
      steps={[
        { pageHeader: dictionary.CREATE_DEPARTMENT_PAGE_HEADER, component: DepartmentForm },
      ]}
    />
  );
};
